import { render, staticRenderFns } from "./GeneralIndicatorsFilter.vue?vue&type=template&id=2fc92cfb&scoped=true"
import script from "./GeneralIndicatorsFilter.vue?vue&type=script&lang=js"
export * from "./GeneralIndicatorsFilter.vue?vue&type=script&lang=js"
import style0 from "./GeneralIndicatorsFilter.vue?vue&type=style&index=0&id=2fc92cfb&prod&scoped=true&lang=css"
import style1 from "./GeneralIndicatorsFilter.vue?vue&type=style&index=1&id=2fc92cfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc92cfb",
  null
  
)

export default component.exports